/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CrewStatus } from '../../models/crew-status';
import { GetSchedulerCrewResponse } from '../../models/get-scheduler-crew-response';
import { Rank } from '../../models/rank';
import { Rotation } from '../../models/rotation';
import { WingType } from '../../models/wing-type';

export interface ListSchedulerCrew$Params {
  page?: number;
  size?: number;
  sort?: string;
  search?: string;
  rank?: Rank;
  wingType?: WingType;
  rotation?: Rotation;

/**
 * Optional. ACTIVE returns only Active crew (including never-set Status). INACTIVE returns only Inactive crew. Omit to return both.
 */
  status?: CrewStatus;
}

export function listSchedulerCrew(http: HttpClient, rootUrl: string, params?: ListSchedulerCrew$Params, context?: HttpContext): Observable<StrictHttpResponse<GetSchedulerCrewResponse>> {
  const rb = new RequestBuilder(rootUrl, listSchedulerCrew.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
    rb.query('sort', params.sort, {});
    rb.query('search', params.search, {});
    rb.query('rank', params.rank, {});
    rb.query('wingType', params.wingType, {});
    rb.query('rotation', params.rotation, {});
    rb.query('status', params.status, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetSchedulerCrewResponse>;
    })
  );
}

listSchedulerCrew.PATH = '/api/scheduler/crew';
